import { render, staticRenderFns } from "./ClientAxonautRelation.vue?vue&type=template&id=9f521eb0"
import script from "./ClientAxonautRelation.vue?vue&type=script&lang=js"
export * from "./ClientAxonautRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports